/* eslint-disable react/no-array-index-key */
// import { useState } from 'react';
import Box from '@mui/material/Box';
import Slider from 'react-slick';
import { Grid } from '@mui/system';
// import im3 from './OBJECTS.svg';
import DownloadButton from '../../../components/layout/DownloadButton';

function MobileApplication({ downloadApplication }) {
  // const [isReversed, setIsReversed] = useState(false);

  const list = downloadApplication?.slider?.files;

  const settings = {
    arrows: false,
    infinite: true,
    slidesToShow: 2.4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 4000,
    autoplaySpeed: 4000,
    cssEase: 'linear',
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1.8,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2.4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
    ],

  };

  return (
    <div
      className="mobileApplication-wrap"
      style={{
        backgroundImage: `url(${downloadApplication?.backgroundImage?.url})`,
      }}>
      <Grid
        container
        sx={{
          justifyContent: 'space-between',
        }}
        >
        <Grid size={{ xs: 12, md: 5 }} sx={{ overflow: 'hidden', display: 'flex', flexDirection: { xs: 'column', sm: 'row', md: 'row' }, justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap' }}>
          {/* <Box sx={{ flexShrink: 0 }}> */}
          <Grid size={{ xs: 12, sm: 11 }}>
            <h2 className="box-title" dangerouslySetInnerHTML={{ __html: downloadApplication?.title }} />
            <p className="box-subtitle" style={{ maxWidth: '380px' }}>{downloadApplication?.description}
            </p>
          </Grid>
          {/* </Box> */}
          <Box pr={3}>
            <Box mt={{ xs: 3, sm: 0, md: 0, lg: 3 }} sx={{ display: 'flex', gap: '20px', justifyContent: 'flex-end' }}>
              {downloadApplication?.appStoreImage?.icon?.url && (
                <img
                  src={`${downloadApplication?.appStoreImage?.icon?.url}`}
                  alt={downloadApplication?.appStoreImage?.name} />
              )}
              {downloadApplication?.playStoreImage?.icon?.url && (
                <img
                  src={`${downloadApplication?.playStoreImage?.icon?.url}`}
                  alt={downloadApplication?.playStoreImage?.name} />
              )}
            </Box>
            <Box mt={3}>
              <DownloadButton />
            </Box>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 7 }}>
          <Box sx={{ width: '100%' }}>
            <div className="slider-container">
              {list && list.length > 0 ? (
                <Slider {...settings}>
                  {list.map((item, slideIdx) => (
                    <div className="slider-card" key={slideIdx}>
                      <img src={`${item?.url}`} className="image-slider" alt="" />
                    </div>
                  ))}
                </Slider>
              ) : (
                <div className="no-slides">No slides available</div>
              )}
            </div>
          </Box>
        </Grid>
      </Grid>
      <Grid />
    </div>
  );
}

export default MobileApplication;
